<template>
  <component
    :is="'default-notification-item'"
    :action="action"
    v-bind="$props"
    :notification="safeNotification">
  </component>
</template>

<script>

import notificationItem from "@/client/extensions/mixins/baseComponents/notificationItem";

export default {
  mixins: [notificationItem],
  props: {
    icon: {
      type: [String, Boolean],
      default: "chat-message-alt",
    },
  },
  data: function () {
    return {};
  },
  computed: {
    action() {
      return {
        ctaComponent: "form-button",
        ctaProps: {
          iconEnd: 'chevron-inline-end',
          text: 'notifications.types.newChatMessage.ctaText',
          size: "s",
        },
        type: 'redirect',
        route: {
          name: "user-dashboard-conversations"
        },
      };
    },
  },
  methods: {
    getSafeNotificationData(notificationData) {
      let res = {};

      if (notificationData && typeof notificationData === "object") {
        res = { ...notificationData };
      }


      // example: enforce senderName
      if (!res.senderName) {
        res.senderName = this.t('notifications.types.newChatMessage.unknownSender');
      }

      // todo: chat UUID

      return res;
    },
  },
};
</script>

<style scoped lang="scss"></style>
